import {
  subtreeIds,
  type TaxonomyIndex,
} from "../offeredServices/catalogueModel.js";

/**
 * The Tolgee key (English text) of the fixed one-line subline under a
 * root-category tile, by category ID. Spelled out so the keys stay
 * statically known to the typed translation function.
 */
const VERTICAL_SUBLINE_KEYS = {
  hvac_and_plumbing: "Heating, sanitary, climate",
  electrical_engineering: "Wiring, smart home, e-mobility",
  civil_engineering: "Earthworks, drainage",
  structural_construction: "Masonry, concrete, timber",
  landscape_construction: "Gardens, paving, fences",
  solar_photovoltaics: "PV, storage, wallboxes",
  specialized_construction: "Tiling, plaster, floors, paint",
  services: "Maintenance, emergencies",
} as const;

export type VerticalSublineKey =
  (typeof VERTICAL_SUBLINE_KEYS)[keyof typeof VERTICAL_SUBLINE_KEYS];

/**
 * The key of the fixed subline of a vertical tile, or `null` for a category
 * without one (e.g. "other"): the tile then shows only its title.
 */
export function getVerticalSublineKey(
  categoryId: string
): VerticalSublineKey | null {
  return Object.hasOwn(VERTICAL_SUBLINE_KEYS, categoryId)
    ? VERTICAL_SUBLINE_KEYS[categoryId as keyof typeof VERTICAL_SUBLINE_KEYS]
    : null;
}

/**
 * The number of services an "apply to all" choice covers: the distinct leaf
 * categories in the subtrees of the selected verticals (a vertical without
 * sub-trades is its own service). Matches where the commit writes services.
 */
export function countServicesBelowVerticals(
  index: TaxonomyIndex,
  verticalIds: readonly string[]
): number {
  const leaves = new Set<string>();
  for (const verticalId of verticalIds) {
    for (const id of subtreeIds(index, verticalId)) {
      if (index.isLeaf(id)) {
        leaves.add(id);
      }
    }
  }
  return leaves.size;
}
